
const customerRooms = [
    {
      id: 1,
      name: "Workplace Case",
      description: "Description of Template here",
      attendedTo: "Mustafa Yıldırım",
      remainingTime: "2 Days 23 Hours",
      status: "50% Completed",
      date: "Apr 23",
    },
    {
      id: 2,
      name: "Workplace Case",
      description: "Description of Template here",
      attendedTo: "Mustafa Yıldırım",
      remainingTime: "2 Days 23 Hours",
      status: "50% Completed",
      date: "Apr 23",
    },
    {
      id: 3,
      name: "Workplace Case",
      description: "Description of Template here",
      attendedTo: "Mustafa Yıldırım",
      remainingTime: "2 Days 23 Hours",
      status: "50% Completed",
      date: "Apr 23",
    },
    {
      id: 4,
      name: "Workplace Case",
      description: "Description of Template here",
      attendedTo: "Mustafa Yıldırım",
      remainingTime: "2 Days 23 Hours",
      status: "50% Completed",
      date: "Apr 23",
    },
    {
      id: 5,
      name: "Workplace Case",
      description: "Description of Template here",
      attendedTo: "Mustafa Yıldırım",
      remainingTime: "2 Days 23 Hours",
      status: "50% Completed",
      date: "Apr 23",
    },
    // Add more dummy data objects as needed
  ];

  export default customerRooms